import React from 'react';

import { FiDownload } from 'react-icons/fi';
import person from '../../assets/person.jpg';

const AboutMe = () => {


    return (
        <div className='min-h-screen p-20'>
            <div className='flex flex-col-reverse md:flex-row justify-around items-center'>
                <div data-aos="fade-up"
                    data-aos-duration="3000">
                    <h1 className='text-4xl'>Hello, I am </h1>
                    <h1 className='text-4xl'>Mahabubul Islam</h1>
                    <p>I am a passionate front-end developer. I want to become a full-stack web developer. I am a quick learner. I love to learn and explore new technologies and grow my skill. I am expertise in HTML5, CSS3, Bootstrap, Tailwind CSS, JavaScript, DOM, React, React Boostrap, Api, React Router, Firebase, Node JS, Express JS, and MongoDB. I completed 4 years Diploma in Engineering degree in Computer Science and Technology.</p>
                    <a href="https://drive.google.com/uc?id=18mOjVQktP_xjZIDuU4YG-PI9Qwd1O3CZ&export=download" download className="btn border-0 m-2 bg-gradient-to-r from-teal-500  to-blue-500 hover:from-blue-500 hover:to-teal-500 duration-300">Download Resume <FiDownload className='font-bold text-xl ml-2'></FiDownload></a>
                </div>
                <div data-aos="fade-down"
                    data-aos-duration="3000">
                    <img src={person} alt="" />
                </div>
            </div>
        </div>
    );
};

export default AboutMe;